import { render, staticRenderFns } from "./Productdetail.vue?vue&type=template&id=57779ec0&"
import script from "./Productdetail.vue?vue&type=script&lang=js&"
export * from "./Productdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports